import {useEffect, useState} from "react";
import {useGetListLibraryModal} from "./useJsonLoader";
import {GeneInfo} from "../types/Types";
import {LibraryModalResult} from "../types/list";

/** Fetches library modal data for the given gene, resetting when the gene changes. */
export function useLibraryData(gene: GeneInfo | null | undefined): LibraryModalResult | null {
  const fetchLibraryModal = useGetListLibraryModal();
  const [libraryData, setLibraryData] = useState<LibraryModalResult | null>(null);

  useEffect(() => {
    if (!gene?.l) {
      setLibraryData(null);
      return;
    }
    setLibraryData(null);
    fetchLibraryModal({get_param: gene.b}).then(data => {
      if (data) setLibraryData(data);
    });
  }, [gene?.b, fetchLibraryModal]);

  return libraryData;
}